import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { Divider as BaseDivider, Box, Flex, Text } from 'Components/Base';
import HTMLView from 'Components/HTMLView';
import { EXAM_PAPER_ITEM_TYPE } from 'Components/Quiz/constant';

import ExamChoice from '../ExamChoice';
import ExamItemWrapper from '../ExamItemWrapper';

const ContentWrapper = styled(Flex)`
  ${({ theme }) => css`
    flex-direction: column;
    gap: ${theme.space[6]}px;
    padding: ${theme.space[6]}px;
    @media (max-width: ${theme.breakpoints[1]}) {
      padding: ${theme.space[4]}px ${theme.space[6]}px;
    }
  `}
`;

const ChoiceWrapper = styled(Flex)`
  ${({ theme }) => css`
    gap: ${theme.space[6]}px;
    flex-direction: column;
  `}
`;

const FooterWrapper = styled(Box)`
  ${({ theme }) => css`
    padding: ${theme.space[7]}px ${theme.space[6]}px;
    @media (max-width: ${theme.breakpoints[1]}) {
      padding: ${theme.space[4]}px ${theme.space[6]}px;
    }
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;

    &.solution.correct {
      background-color: ${theme.colors.backgroundGreenLight};
    }

    &.solution.incorrect {
      background-color: ${theme.colors.backgroundYellowLight};
    }
  `}
`;

const Divider = styled(BaseDivider)`
  ${({ theme }) => css`
    margin: 0;
    border: 1px solid ${theme.colors.greyscale.grey4};

    &.solution.correct {
      border: 1px solid ${theme.colors.backgroundGreen};
    }

    &.solution.incorrect {
      border: 1px solid ${theme.colors.backgroundYellow};
    }
  `}
`;

const ScoreBox = styled(Box)`
  ${({ theme }) => css`
    width: 119px;
    height: 40px;
    background-color: ${theme.colors.greyscale.grey4};
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `}
`;

const ScoreLabel = styled(Text)`
  font-weight: normal;
`;

const ScoreNumber = styled(Text)`
  font-weight: bold;
`;
const ExamQuestion = (props) => {
  const {
    question,
    choices,
    selectedChoices,
    onChoiceClick,
    footerAction,
    correctAnswerIndices,
    isCorrect,
    variant = 'default',
    containerClassName = '',
    ref,
    questionType,
  } = props;
  let footerClassName = '';

  footerClassName += variant === 'solution' ? (isCorrect ? 'correct ' : 'incorrect ') : '';
  footerClassName += variant === 'solution' ? 'solution ' : '';

  return (
    <ExamItemWrapper className={containerClassName} ref={ref}>
      <ContentWrapper>
        <HTMLView rawContent={question} />
        {choices && choices.length && (
          <ChoiceWrapper>
            {choices.map((choice, index) => (
              <ExamChoice
                key={`${choice.id}-${index}`}
                choice={choice}
                isSelected={Array.isArray(selectedChoices) && selectedChoices.includes(index)}
                onClick={onChoiceClick}
                index={index}
                variant={variant}
                isCorrect={
                  variant === 'solution'
                    ? Array.isArray(selectedChoices) && selectedChoices.includes(index)
                      ? Array.isArray(correctAnswerIndices) && correctAnswerIndices.includes(index)
                      : null
                    : null
                }
                questionType={questionType}
              />
            ))}
          </ChoiceWrapper>
        )}
        {variant === 'solution' && questionType === 'MULTIPLE_SELECT' && (
          <Flex justifyContent="space-between" gridColumnGap={4}>
            <ScoreBox className={footerClassName}>
              <ScoreLabel>ตอบถูก: </ScoreLabel>
              <ScoreNumber>
                {Array.isArray(selectedChoices) && Array.isArray(correctAnswerIndices)
                  ? selectedChoices.filter((index) => correctAnswerIndices.includes(index)).length
                  : 0}
                /{Array.isArray(correctAnswerIndices) ? correctAnswerIndices.length : 0}
              </ScoreNumber>
            </ScoreBox>
          </Flex>
        )}
      </ContentWrapper>
      {footerAction && (
        <>
          <Divider className={footerClassName} />
          <FooterWrapper className={footerClassName}>{footerAction}</FooterWrapper>
        </>
      )}
    </ExamItemWrapper>
  );
};

ExamQuestion.propTypes = {
  question: PropTypes.string.isRequired,
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  selectedChoices: PropTypes.arrayOf(PropTypes.number),
  onChoiceClick: PropTypes.func,
  footerAction: PropTypes.node,
  correctAnswerIndices: PropTypes.arrayOf(PropTypes.number),
  variant: PropTypes.oneOf(['default', 'solution']),
  isCorrect: PropTypes.bool,
  containerClassName: PropTypes.string,
  ref: PropTypes.object,
  questionType: PropTypes.oneOf(Object.values(EXAM_PAPER_ITEM_TYPE)),
};

export default ExamQuestion;
